import { render, staticRenderFns } from "./DropdownInput.vue?vue&type=template&id=6f0873f6&"
import script from "./DropdownInput.vue?vue&type=script&lang=ts&"
export * from "./DropdownInput.vue?vue&type=script&lang=ts&"
import style0 from "./DropdownInput.vue?vue&type=style&index=0&id=6f0873f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports